import { SxProps, Theme } from '@mui/material';
import { Colors, inputPlaceholderColor } from '../../constants';

export const paperStyles: SxProps<Theme> = {
	p: '8px 4px',
	margin: '7px 0',
	backgroundColor: Colors.black_a40,
	backdropFilter: 'blur(6px)',

	"& .MuiAutocomplete-listbox": {
		p: 0,
		maxHeight: '350px',

		"& .MuiAutocomplete-option": {
			display: 'flex',
			alignItems: 'center',
			borderRadius: '8px',
			height: '58px',
			p: '8px 8px 8px 12px',
			fontWeight: 500,
			lineHeight: '21px',
			fontSize: '14px',
			color: Colors.white,

			"&:hover, &.Mui-focused": {
				backgroundColor: Colors.white_a10,
			},

			"& >svg": {
				width: '18px',
				height: '18px',
				mr: '8px',
				color: Colors.gray,
			},
		}
	}
};

export const textFieldStyles: SxProps<Theme> = {
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: Colors.black
	},

	'&.Mui-error .MuiOutlinedInput-notchedOutline': {
		borderColor: Colors.error
	},

	'&.MuiOutlinedInput-root': {
		'& >svg': {
			mr: '10px',
			width: '18px',
			height: '18px',
			color: Colors.gray,
		},

		'& .MuiAutocomplete-input': {
			color: Colors.white,
			p: 0,
			height: '20px',

			'&::placeholder': {
				opacity: 1,
				color: inputPlaceholderColor,
			},
		},

		'& .MuiAutocomplete-endAdornment': {
			transform: 'translateY(-50%)',
			top: '50%',
			right: '20px',
			width: '24px',
			height: '24px',

			"& .MuiButtonBase-root": {
				p: 0,
				backgroundColor: 'transparent',

				"& .MuiSvgIcon-root": {
					width: '24px',
					height: '24px',
				}
			}
		},

		'& .MuiAutocomplete-popupIndicator': {
			transform: 'translateY(-50%) rotate(180%)',
		}
	}
};
